import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import ErrorLabel from '../../components/error';
export function DateInput2({ name, title, placeholder = '', errorLabel, onSelect, type = "date", extraClasses = "", value, ...props }) {
    const { t: trans, i18n } = useTranslation(["info"]);
    let lang = (i18n.language || 'ar');
    let languageDir = "language-" + lang;
    const ref = useRef();
    return (

        <div className={"input " + languageDir}>

            {
                title &&
                <label className={"input-label"} htmlFor={name}>{title}</label>
            }
            <label htmlFor={name} className={"m-0 w-100 custom-input-file " + (errorLabel && 'border-danger')}>

                <input
                    id={name}
                    inputMode='none'
                    lang="en-us"
                    placeholder={placeholder}
                    onClick={(e) => {
                        try {
                            e.target.showPicker();
                        } catch (error) { }
                    }}
                    ref={ref}
                    onFocus={(e) => {
                        try {
                            e.target.showPicker();
                        } catch (error) { }
                    }}
                    min={new Date().setHours(5, 59, 0, 0)}
                    onChange={(e) => onSelect(e)}
                    value={value}
                    name={name}
                    className={`input-field object-full ${extraClasses}`}
                    type={type}
                    {...props}
                />

                <div className={"custom-input-file-content"}>
                    <input
                        className={"input-field"}
                        readOnly={true}
                        placeholder={placeholder}
                        value={value}
                        type={"text"}
                        style={{ border: 'none', minHeight: 'unset', padding: 0 }}
                    />
                    <img src={"/assets/icons/calender_icon.svg"} alt="calendar" />
                </div>
            </label>
            <ErrorLabel errorTitle={errorLabel} />
        </div>
    );
}
